export const HomeVariables = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Green Kurpie",
  headline: "Visit Myszyniec and learn about the Kurpie culture.",
  description:
    "There used to be a huge forest here ... Until a few hundred years ago it was inhabited by settlers, for whom the cavernous forests were not dangerous and the ability to operate a shotgun and use the gifts of the forest came almost naturally. Today rediscovered.",
  buttonLabel: "See More",
  imgStart: false,
  img: require("../../img/img1.png"),
  alt: "Culture",
  dark: true,
  primary: true,
  darkText: true,
};

export const HomeVariablesTwo = {
  id: "culture",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Culture",
  headline: "Cutouts and Folk Costumes",
  description:
    "Kurpie folk art found its expression primarily in construction, ornamentation, sculpture, weaving and cutting. Old customs varied with songs and dances are cultivated, and the dialect is still used.",
  buttonLabel: "See More",
  imgStart: true,
  img: require("../../img/img2.png"),
  alt: "Culture",
  dark: true,
  primary: true,
  darkText: false,
};
export const HomeVariablesThree = {
  id: "forest",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Primeval Forest",
  headline: "Czarnia Reserve",
  description:
    "Primary forest is a forest that has not been subject to direct or indirect modification by humans, primary forest ecosystem.",
  buttonLabel: "See More",
  imgStart: false,
  img: require("../../img/img5.jpg"),
  alt: "Culture",
  dark: true,
  primary: true,
  darkText: true,
};
export const HomeVariablesFour = {
  id: "offer",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Contact Us",
  headline: "Need More Information ? Click the button",
  description:
    "in our tradition, we welcome guests with: bread, salt and vodka. We hope to welcome you!",
  buttonLabel: "Contact",
  imgStart: false,
  img: require("../../img/img4.jpg"),
  alt: "Culture",
  dark: true,
  primary: true,
  darkText: false,
};

// export const HomeVariablesTwo = {
//   id: "discover",
//   lightBg: true,
//   lightText: false,
//   lightTextDesc: true,
//   topLine: "Discover",
//   headline: "Visit Myszyniec and learn about the Kurpie culture.",
//   description:
//     "There used to be a huge forest here ... Until a few hundred years ago it was inhabited by settlers, for whom the cavernous forests were not dangerous and the ability to operate a shotgun and use the gifts of the forest came almost naturally. Today rediscovered.",
//   buttonLabel: "See More",
//   imgStart: true,
//   img: require("../../img/img2.png"),
//   alt: "Culture",
//   dark: true,
//   primary: true,
//   darkText: false,
// };
